import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import PencilSvg from './pencil.svg';
import defaultSvgAttributes from './defaultSvgAttributes.js';

const Pencil = ({className, ...props}) => (
  <PencilSvg
    {...defaultSvgAttributes}
    {...props}
    className={classNames("hx-icon-pencil", className)}
    preserveAspectRatio="xMidYMid meet"
  />
);

Pencil.propTypes = {
  className: PropTypes.string
};

export default Pencil;
